/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Amendment_Queue_DescriptionInputs */

const en_orders_amendment_queue_description = /** @type {(inputs: Orders_Amendment_Queue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On-hold orders waiting on amendment payment review.`)
};

const es_orders_amendment_queue_description = /** @type {(inputs: Orders_Amendment_Queue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos en espera que esperan revision de pago por enmienda.`)
};

/**
* | output |
* | --- |
* | "On-hold orders waiting on amendment payment review." |
*
* @param {Orders_Amendment_Queue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_amendment_queue_description = /** @type {((inputs?: Orders_Amendment_Queue_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Amendment_Queue_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_amendment_queue_description(inputs)
	return es_orders_amendment_queue_description(inputs)
});